export default __webpack_public_path__ + "s10.png";